import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

import {DOCUMENT_TYPES} from '../../../constants';
import {isRollforwardFlow} from './CreateDocumentModal.utils';
import {
  DARK_TEXT_COLOR,
  GREEN_BUTTON,
  GREY_90,
  GREY_BORDER_DEFAULT,
  WHITE_100,
} from '../../../theme';

const localStyles = {
  label: {
    color: DARK_TEXT_COLOR,
    fontSize: '0.875rem',
    fontWeight: '500',
    letterSpacing: '-0.14px',
    lineHeight: '130%',
  },
  switch: {
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          backgroundColor: GREEN_BUTTON,
          opacity: 1,
        },
        color: GREEN_BUTTON,
        transform: 'translateX(12px)',
      },
      padding: '2px',
    },
    '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
      backgroundColor: WHITE_100,
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: GREY_90,
      height: 16,
      width: 16,
    },
    '& .MuiSwitch-track': {
      backgroundColor: GREY_BORDER_DEFAULT,
      borderRadius: 100,
      opacity: 1,
    },
    height: 20,
    padding: 0,
    width: 32,
  },
};

export const YtdToggle = ({
  createFlow,
  documentType,
  includesYtd,
  setIncludesYtd,
}) => {
  if (
    documentType !== DOCUMENT_TYPES.quarterlyReport ||
    !isRollforwardFlow(createFlow)
  ) {
    return null;
  }

  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
      width="100%"
    >
      <Typography sx={localStyles.label}>Include YTD information</Typography>
      <Switch
        checked={includesYtd}
        onChange={(e) => setIncludesYtd(e.target.checked)}
        sx={localStyles.switch}
      />
    </Stack>
  );
};

YtdToggle.propTypes = {
  createFlow: PropTypes.string,
  documentType: PropTypes.string.isRequired,
  includesYtd: PropTypes.bool.isRequired,
  setIncludesYtd: PropTypes.func.isRequired,
};
